












import { Component, Prop, Vue } from 'vue-property-decorator'
import PrintReportCheckSheetItem from './PrintReportCheckSheetItem.vue'

@Component({
  components: {
    PrintReportCheckSheetItem
  }
})
export default class extends Vue {
  @Prop({
    default: false
  })
  oos!: boolean

  @Prop({
    default: false
  })
  compact!: boolean

  @Prop()
  otherValue?: string
}
